export const CHECKOUT_URL = 'https://dvoworkflow-en.impultienda.ar/checkout/';

export const COUNTDOWN_SECONDS = 17 * 60 + 34; // 00:17:34

export const IMAGES = {
  bundle: 'https://cdn.magicpatterns.com/uploads/byhzcgLrEpK3yGrYnC3MbE/DVO_WORKFLOW-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/2e2TE4ASUDKnvNgvb96ajY/Dra._Karito_Odontologa_OF.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/6oexSEbu4D3t7P7SUsWPNc/BONUS_1_DVO_WORKFLOW.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/bzoT1TqzGfS8xVUurwf8jn/BONUS_2_DVO_WORKFLOW.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/kq7KQk3h9EdGUnM7H78XYx/BONUS_3_DVO_WORKFLOW.png',
  bonus4: 'https://cdn.magicpatterns.com/uploads/jZgT4Re4Px5RtErNvDtwDL/BONUS_4_DVO_WORKFLOW.png',
  bonus5: 'https://cdn.magicpatterns.com/uploads/1HznHjMss6RWscKvhta1Nu/BONUS_5_DVO_WORKFLOW.png',
};

export const SPOTS = {
  total: 200,
  left: 17,
  claimedPercent: 92,
};
